import { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import { useSelector } from "react-redux";
import tw from "tailwind-styled-components";

import {
  ActionSection,
  ModalHeader,
  SideCancelBtn,
  SubmitBtn,
} from "../Styles/InputStyles";

const PendingPaymentFilter = ({
  onApplyFilter,
  handleClose,
  selectedLocationId,
  setSelectedLocationId,
}) => {
  const locations = useSelector(
    (state) => state.LocationsReducer.locations
  );
  const [tempLocationId, setTempLocationId] = useState(selectedLocationId);

  useEffect(() => {
    setTempLocationId(selectedLocationId);
  }, [selectedLocationId]);

  const filteredLocations = locations.filter(
    (location) => location.id !== 0
  );

  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => setHeight(window.innerHeight);

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleApply = () => {
    //setSelectedLocationId(tempLocationId);
    const location = filteredLocations?.find((loc) => loc.id === tempLocationId);

    onApplyFilter(
      tempLocationId,
      location?.name || `Location ${tempLocationId}`,
      "Location",
    );
    //onApplyFilter(tempLocationId);
  };

  const handleClear = () => {
    //setSelectedLocationId(null);
    onApplyFilter(null, null, null);
    setTempLocationId(null);
  };

  return (
    <Container
      style={{
        height: `${height}px`,
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      <ModalHeader>
        <h1 className="text-lg font-medium text-white">
          Filter by Location
        </h1>

        <button onClick={handleClose}>
          <MdClose color="white" size={24} />
        </button>
      </ModalHeader>

      <Body>
        <div className="w-full px-5 py-5">
          <h3 className="mb-4 text-sm font-semibold text-gray-700">
            Select Location
          </h3>

          <div className="space-y-2 pb-12">
            {filteredLocations.length > 0 ? (
              filteredLocations.map((location) => (
                <OptionRow
                  key={location.id}
                  onClick={() => setTempLocationId(location.id)}
                  className="cursor-pointer"
                >
                  <input
                    type="radio"
                    checked={tempLocationId === location.id}
                    readOnly
                    className="h-4 w-4"
                  />

                  <span className="text-sm text-gray-700">
                    {location.name}
                  </span>
                </OptionRow>
              ))
            ) : (
              <div className="py-6 text-center text-sm text-gray-400">
                No locations available
              </div>
            )}
          </div>
        </div>
      </Body>

      <ActionSection>
        <SideCancelBtn
          type="button"
          onClick={
            tempLocationId ? handleClear : handleClose
          }
          className={
            tempLocationId
              ? "!text-red-500 hover:!bg-red-50"
              : ""
          }
        >
          {tempLocationId ? "Clear" : "Cancel"}
        </SideCancelBtn>

        <SubmitBtn
          type="button"
          onClick={handleApply}
          disabled={!tempLocationId}
          className="disabled:cursor-not-allowed disabled:opacity-50"
        >
          Apply
        </SubmitBtn>
      </ActionSection>
    </Container>
  );
};

const Container = tw.div`
  bg-white
  w-full
  h-full
  flex
  flex-col
`;

const Body = tw.div`
  flex-1
  overflow-y-auto
`;

const OptionRow = tw.label`
  flex
  items-center
  gap-3
  rounded-lg
  border
  border-transparent
  px-3
  py-3
  transition-all
  hover:bg-gray-50
  hover:border-gray-200
`;

export default PendingPaymentFilter;